import Heap from "@heap/react-native-heap";
import { useEffect } from "react";
import { RootState } from "../redux/reducers";
import { useSelector } from "react-redux";
import { toAccountBalanceString } from "../utils/money";
import { Platform } from "react-native";
import Auryc from "rn-auryc-sdk";

export const useHeapAnalytics = (reservations: any) => {
  const userInfo = useSelector((state: RootState) => state?.auth?.userInfo);
  const logger = useSelector((state: RootState) => state.logger);

  useEffect(() => {
    //__DEV__ = true for both mobile and web when running locally, this check is only to remove the warnings when developing locally.
    //mobile: Heap doesn't work with Expo Go, data will only be sent if installed in device or emulator.
    //web: Heap data will only be sent after deployed to environment.
    if (!__DEV__ && userInfo.username) {
      try {
        let heap;
        let auryc;
        const userName = userInfo?.username?.toLowerCase();
        if (Platform.OS == "web") {
          heap = window.heap;
          auryc = window.auryc;
        } else {
          heap = Heap;
          auryc = Auryc;
        }
        logger.info(`Heap and Auryc using ${userName} as identifier`);
        //Heap is case sensitive so we need to normalize the identity
        heap.identify(userName);
        auryc.identify(userName);

        let heapUserProperties = {
          domusoUserId: userInfo?.domusoId,
          firstName: `${userInfo?.given_name}`,
          lastName: `${userInfo?.family_name}`,
          reservationId: "",
          tCode: "",
          rCode: "",
          accountSystemType: "",
          propertyName: "",
          propertyCode: "",
          companyName: "",
          balanceDue: "",
          allowedPayments: "",
        };

        if (reservations && reservations.length) {
          logger.info(
            `Found ${reservations.length} reservation(s) setting Heap and Auryc user properties`
          );

          reservations.forEach((reservation: any) => {
            //Reservation info
            heapUserProperties.reservationId += heapUserProperties?.reservationId
              ? "," + `${reservation?.id}`
              : `${reservation?.id}`;

            heapUserProperties.tCode += heapUserProperties?.tCode
              ? "," + `${reservation?.accounting_details?.tCode}`
              : `${reservation?.accounting_details?.tCode}`;

            heapUserProperties.accountSystemType += heapUserProperties?.accountSystemType
              ? "," + `${reservation?.accounting_details?.accountSystemType}`
              : `${reservation?.accounting_details?.accountSystemType}`;

            if (
              !heapUserProperties.accountSystemType ||
              heapUserProperties.accountSystemType === "undefined"
            ) {
              heapUserProperties.accountSystemType = "";
              heapUserProperties.accountSystemType += heapUserProperties?.accountSystemType
                ? "," + `${reservation?.account_system_type}`
                : `${reservation?.account_system_type}`;
            }

            heapUserProperties.rCode += heapUserProperties?.rCode
              ? "," + `${reservation?.accounting_details?.rCode}`
              : `${reservation?.accounting_details?.rCode}`;

            const balanceDue = toAccountBalanceString(reservation?.accounting_details?.balanceDue);
            heapUserProperties.balanceDue += heapUserProperties?.balanceDue
              ? "," + `${balanceDue}`
              : `${balanceDue}`;

            heapUserProperties.allowedPayments += heapUserProperties?.allowedPayments
              ? "," + `${reservation?.accounting_details?.allowedPayments}`
              : `${reservation?.accounting_details?.allowedPayments}`;

            //Property info
            heapUserProperties.propertyName += heapUserProperties?.propertyName
              ? "," + `${reservation?.property?.name}`
              : `${reservation?.property?.name}`;

            heapUserProperties.propertyCode += heapUserProperties?.propertyCode
              ? "," + `${reservation?.property?.code}`
              : `${reservation?.property?.code}`;

            heapUserProperties.companyName += heapUserProperties?.companyName
              ? "," + `${reservation?.property?.company_name}`
              : `${reservation?.property?.company_name}`;
          });
        }

        heap.addUserProperties({
          ...heapUserProperties,
        });

        auryc.addUserProperties({
          ...heapUserProperties,
        });
      } catch (e) {
        logger.info("Error while adding Heap and Auryc user properties");
        logger.error(e);
      }
    }
  }, [reservations]); //Will only be called if Reservations list change by the parent caller.
};
